import { render, staticRenderFns } from "./gc-dashboard-ytd-card.vue?vue&type=template&id=2273056a&scoped=true"
import script from "./gc-dashboard-ytd-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-ytd-card.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-ytd-card.vue?vue&type=style&index=0&id=2273056a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273056a",
  null
  
)

export default component.exports